'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShowThreadListButton = undefined;

var _reselect = require('reselect');

var _getThreadList = require('./getThreadList');

var _getCurrentView = require('../../current-view/selectors/getCurrentView');

var _views = require('../../current-view/constants/views');

var getIsThreadListView = (0, _reselect.createSelector)([_getCurrentView.getCurrentView], function (currentView) {
  return currentView === _views.THREAD_LIST;
});

var getShowThreadListButton = exports.getShowThreadListButton = (0, _reselect.createSelector)([_getThreadList.getThreadList, getIsThreadListView], function (threads, isThreadListRoute) {
  if (!threads || isThreadListRoute) return false;

  var numThreads = threads.size;
  var hasThreadsForThreadList = numThreads > 0;

  return hasThreadsForThreadList;
});


//////////////////
// WEBPACK FOOTER
// ./js/threads/selectors/getShowThreadListButton.js
// module id = 1040
// module chunks = 2 3